module.exports = __webpack_public_path__ + "static/media/TRX-BNB.72cdf98a.svg";